import Axios from "axios";
import { API_HOST, axiosInstance, axiosRequestWithAuth } from "../constants/server.constant";


const createApplicationCredential = async (requestBody) => {
    return await axiosInstance.post(API_HOST + "/appcred/create", requestBody, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return null;
    });
};

const listApplicationCredential = async (requestBody) => {
    return await axiosInstance.get(API_HOST + "/appcred/list", axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return null;
    });
};

const deleteApplicationCredential = async (id, name) => {
    return await axiosInstance.delete(API_HOST + "/appcred/delete/" + id + "/" + name, axiosRequestWithAuth).then(resp => {
        return resp;
    }).catch(error => {
        return null;
    });
};

export const ApplicationService = {
    createApplicationCredential,
    listApplicationCredential,
    deleteApplicationCredential
};